import { render, staticRenderFns } from "./AssignUsersForm.vue?vue&type=template&id=a07d466a"
import script from "./AssignUsersForm.vue?vue&type=script&lang=js"
export * from "./AssignUsersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports